/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as i from "react";
import e from "prop-types";
import { packageMetadata as T } from "../package-metadata.mjs";
import { validatePackage as j, useId as R, classNames as A } from "@progress/kendo-react-common";
const c = i.forwardRef((t, g) => {
  j(T);
  const r = i.useRef(null), d = i.useCallback(
    () => ({
      element: r.current
    }),
    []
  );
  i.useImperativeHandle(g, d);
  const { className: m, style: u, id: h, children: y, gap: a = o.gap } = t, f = R(), n = i.useMemo(
    () => t.align && t.align.horizontal ? t.align.horizontal : o.hAlign,
    [t.align]
  ), l = i.useMemo(
    () => t.align && t.align.vertical ? t.align.vertical : o.vAlign,
    [t.align]
  ), p = i.useMemo(
    () => A(
      "k-grid-layout",
      {
        "k-justify-items-start": n === "start",
        "k-justify-items-center": n === "center",
        "k-justify-items-end": n === "end",
        "k-justify-items-stretch": n === "stretch",
        "k-align-items-start": l === "top",
        "k-align-items-center": l === "middle",
        "k-align-items-end": l === "bottom",
        "k-align-items-stretch": l === "stretch"
      },
      m
    ),
    [n, l, m]
  ), k = a ? `${typeof a.rows == "number" ? a.rows + "px" : a.rows} ${typeof a.cols == "number" ? a.cols + "px" : a.cols}` : void 0, v = t.rows && t.rows.map((s) => `${typeof s.height == "number" ? s.height + "px" : s.height}`).join(" "), b = t.cols && t.cols.map((s) => `${typeof s.width == "number" ? s.width + "px" : s.width}`).join(" "), w = {
    gap: k,
    gridTemplateColumns: b,
    gridTemplateRows: v,
    ...u
  };
  return /* @__PURE__ */ i.createElement(
    "div",
    {
      ref: r,
      className: p,
      style: w,
      id: h || f
    },
    y
  );
}), o = {
  hAlign: "stretch",
  vAlign: "stretch",
  gap: void 0
};
c.propTypes = {
  className: e.string,
  style: e.object,
  children: e.any,
  id: e.string,
  gap: e.shape({
    rows: e.oneOfType([e.string, e.number]),
    columns: e.oneOfType([e.string, e.number])
  }),
  align: e.shape({
    vertical: e.oneOf(["top", "middle", "bottom", "stretch"]),
    horizontal: e.oneOf(["start", "center", "end", "stretch"])
  })
};
c.displayName = "KendoReactGridLayout";
export {
  c as GridLayout
};
